const sidebarLocalstorageVariable = 'isSidebarOpen';

export const getIsSidebarOpen = () =>
  localStorage.getItem(sidebarLocalstorageVariable);

export const setIsSidebarOpen = (value: string) =>
  localStorage.setItem(sidebarLocalstorageVariable, value);
